"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "QueueService", {
    enumerable: true,
    get: function() {
        return QueueService;
    }
});
const _common = require("@nestjs/common");
const _pqueue = /*#__PURE__*/ _interop_require_default(require("p-queue"));
const _emittery = /*#__PURE__*/ _interop_require_default(require("emittery"));
const _cronparser = require("cron-parser");
const _jobseventservice = require("~/modules/jobs/jobs-event.service");
const _Jobs = require("~/interface/Jobs");
const _jobsmapservice = require("~/modules/jobs/jobs-map.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let QueueService = class QueueService {
    async jobWrapper(job) {
        this.emitter.emit(_Jobs.JobStatus.ACTIVE, {
            job
        });
        try {
            if (!this.jobsMap.jobs[job.name]) {
                // job not found - skip
                return;
            }
            const { this: processor, fn = 'job' } = this.jobsMap.jobs[job.name];
            const result = await processor[fn](job);
            this.emitter.emit(_Jobs.JobStatus.COMPLETED, {
                job,
                result
            });
        } catch (error) {
            this.emitter.emit(_Jobs.JobStatus.FAILED, {
                job,
                error
            });
        }
    }
    get emitter() {
        return QueueService._emitter;
    }
    get queue() {
        return QueueService.queue;
    }
    get queueMemory() {
        return QueueService.queueMemory;
    }
    get queueIndex() {
        return QueueService.queueIdCounter;
    }
    set queueIndex(index) {
        QueueService.queueIdCounter = index;
    }
    add(name, data, opts) {
        const id = (opts == null ? void 0 : opts.jobId) || `${this.queueIndex++}`;
        const existingJob = this.queueMemory.find((q)=>q.id === id);
        let job;
        const helperFns = (timeoutRef = null)=>{
            return {
                getState: ()=>Promise.resolve(job.status),
                moveToCompleted: (returnValue, _ignoreLock)=>{
                    if (timeoutRef) {
                        clearTimeout(timeoutRef);
                    }
                    this.emitter.emit(_Jobs.JobStatus.COMPLETED, {
                        job,
                        result: returnValue,
                        skipEvent: true
                    });
                },
                moveToFailed: (error, _ignoreLock)=>{
                    if (timeoutRef) {
                        clearTimeout(timeoutRef);
                    }
                    this.emitter.emit(_Jobs.JobStatus.FAILED, {
                        job,
                        error,
                        skipEvent: true
                    });
                }
            };
        };
        if (existingJob) {
            // if job is already in memory and has a repeat, return the job
            if (existingJob.repeat) {
                return existingJob;
            }
            if (existingJob.status !== _Jobs.JobStatus.WAITING) {
                existingJob.status = _Jobs.JobStatus.WAITING;
            }
            job = existingJob;
        } else {
            job = _extends({
                id: `${id}`,
                name,
                status: _Jobs.JobStatus.WAITING,
                data,
                repeat: opts == null ? void 0 : opts.repeat,
                delay: opts == null ? void 0 : opts.delay
            }, helperFns());
        }
        if (opts == null ? void 0 : opts.repeat) {
            // Initialize recurring job execution based on cron pattern
            const scheduleNextExecution = ()=>{
                try {
                    const cron = _cronparser.CronExpressionParser.parse(opts.repeat.cron);
                    const nextExecutionTime = cron.next().toDate();
                    const delayMs = Math.max(0, nextExecutionTime.getTime() - Date.now());
                    const recurringJobId = `${id}-${Date.now()}`;
                    const childJob = _extends({}, job, {
                        id: recurringJobId
                    });
                    setTimeout(()=>{
                        this.queueMemory.push(childJob);
                        // Execute the current job
                        this.queue.add(()=>this.jobWrapper(childJob)).then(()=>{
                            // Schedule the next execution only after current job completes
                            this.queue.add(()=>scheduleNextExecution());
                        }).catch((error)=>{
                            console.error(`Failed to schedule recurring job ${name}:`, error);
                            // Try to reschedule despite the error
                            this.queue.add(()=>scheduleNextExecution());
                        });
                    }, delayMs);
                } catch (error) {
                    console.error(`Invalid cron expression for job ${name}:`, error);
                }
            };
            this.queueMemory.push(job);
            // Start the recurring job process
            scheduleNextExecution();
        } else if (opts == null ? void 0 : opts.delay) {
            if (!existingJob) {
                this.queueMemory.push(job);
            }
            const jobTimeout = setTimeout(()=>{
                this.queue.add(()=>this.jobWrapper(job));
            }, opts.delay).unref();
            Object.assign(job, helperFns(jobTimeout));
        } else {
            if (!existingJob) {
                this.queueMemory.push(job);
            }
            this.queue.add(()=>this.jobWrapper(job));
        }
        return job;
    }
    getJobs(types) {
        types = Array.isArray(types) ? types : [
            types
        ];
        return this.queueMemory.filter((q)=>types.includes(q.status));
    }
    getJob(id) {
        return this.queueMemory.find((q)=>q.id === id);
    }
    // remove job from memory
    removeJob(job) {
        const fIndex = this.queueMemory.findIndex((q)=>q.id === job.id);
        if (fIndex) {
            this.queueMemory.splice(fIndex, 1);
        }
    }
    constructor(jobsEventService, jobsMap){
        this.jobsEventService = jobsEventService;
        this.jobsMap = jobsMap;
        this.emitter.on(_Jobs.JobStatus.ACTIVE, (data)=>{
            const job = this.queueMemory.find((job)=>job.id === data.job.id);
            job.status = _Jobs.JobStatus.ACTIVE;
            this.jobsEventService.onActive.apply(this.jobsEventService, [
                job
            ]);
        });
        this.emitter.on(_Jobs.JobStatus.COMPLETED, (data)=>{
            const job = this.queueMemory.find((job)=>job.id === data.job.id);
            job.status = _Jobs.JobStatus.COMPLETED;
            if (!data.skipEvent) {
                this.jobsEventService.onCompleted.apply(this.jobsEventService, [
                    job,
                    data.result
                ]);
            }
            // clear job from memory
            this.removeJob(job);
        });
        this.emitter.on(_Jobs.JobStatus.FAILED, (data)=>{
            const job = this.queueMemory.find((job)=>job.id === data.job.id);
            job.status = _Jobs.JobStatus.FAILED;
            if (!data.skipEvent) {
                this.jobsEventService.onFailed.apply(this.jobsEventService, [
                    job,
                    data.error
                ]);
            }
            // clear job from memory
            this.removeJob(job);
        });
    }
};
QueueService.queue = new _pqueue.default({
    concurrency: 2
});
QueueService.queueIdCounter = 1;
QueueService.processed = 0;
QueueService.queueMemory = [];
QueueService._emitter = new _emittery.default();
QueueService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(1, (0, _common.Inject)((0, _common.forwardRef)(()=>_jobsmapservice.JobsMap))),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobseventservice.JobsEventService === "undefined" ? Object : _jobseventservice.JobsEventService,
        typeof _jobsmapservice.JobsMap === "undefined" ? Object : _jobsmapservice.JobsMap
    ])
], QueueService);
